"use strict";
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var cio_datamodel = require("cio-datamodel");
if (typeof window !== 'undefined')
    var ui_extensions = require("ui-extensions");
var SelectionAccuracy = require("../../selection/selectionAccuracy.js");
var SnapSet = require("../../../extensions/snap/snapSet.js");
var cio_config = require("cio-config");
var GridInteraction = require("../../../abstract/gridInteraction.js");
var AbstractPosAngleInteractionModel = require("../../../abstract/abstractPosAngleInteractionModel.js");

var TriangleInteractionModel = function (triangleData, editorModel, options) {
    AbstractPosAngleInteractionModel.call(this, triangleData, editorModel);

    this.addGridInteraction(this, editorModel);

    this.origin = editorModel.origin();
    this.editorModel = editorModel;
    this.options = options || {};

    this.showStrokeWidth = this.shadow("showStrokeWidth",
        function () {
            return this.data.strokeWidth() / this.origin.getGridFactor();
        },
        function (strokeWidth) {
            return this.data.strokeWidth(Math.abs(strokeWidth || 0) * this.origin.getGridFactor());
        },
        [this.data.strokeWidth, this.origin.grid_unit]
    );

    this.showWidth = this.shadow("showWidth",
        function () {
            return this.data.width() / this.origin.getGridFactor();
        },
        function (width) {
            return this.data.width((width || 0) * this.origin.getGridFactor());
        },
        [this.data.width, this.origin.grid_unit]
    );

    this.showHeight = this.shadow("showHeight",
        function () {
            return this.data.height() / this.origin.getGridFactor();
        },
        function (height) {
            return this.data.height((height || 0) * this.origin.getGridFactor());
        },
        [this.data.height, this.origin.grid_unit]
    );
};
lib_core.inherit(TriangleInteractionModel, AbstractPosAngleInteractionModel);
lib_core.mixin(TriangleInteractionModel, GridInteraction);
lib_core.JsonParser.registerClass(TriangleInteractionModel, "TriangleInteractionModel");

module.exports = TriangleInteractionModel;

TriangleInteractionModel.prototype.getInspectorElements = function () {
    var inspectorElements = AbstractPosAngleInteractionModel.prototype.getInspectorElements.call(this);

    inspectorElements.input_elements.push(
        {
            label: 'Width',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showWidth,
            datatype   : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Height',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showHeight,
            datatype   : cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Stroke Width',
            type: ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember: this.showStrokeWidth,
            datatype: cio_config.types.positive_float,
            unitmember : this.origin.showUnitString
        },
        {
            label: 'Fill',
            type: ui_extensions.InspectorInputType.CHECKBOX,
            datamember: this.data.fill
        }
    );

    inspectorElements.help_elements = {
        'name': 'Triangle'
    };

    return inspectorElements;
};

TriangleInteractionModel.prototype.getSnapSet = function () {
    var snapSet = new SnapSet();
    var pointsx = [-this.data.width()/2, 0, this.data.width()/2];
    var pointsy = [this.data.height()/2, -this.data.height()/2, this.data.height()/2];
    var pos = this.data.pos();
    for(var i = 0; i < 3; i++) {
        var curCord = new lib_geometry.Coord(pos.getX() + pointsx[i],
            pos.getY() + pointsy[i]).rotate(this.data.angle(), pos);
        snapSet.addHor(curCord, 1);
        snapSet.addVer(curCord, 1);
        curCord = null;
    }
    pos = pointsx = pointsy = null; // cleanup
    return snapSet;
};

TriangleInteractionModel.prototype.width = function (val) {
    return this.data.width(val);
};

TriangleInteractionModel.prototype.height = function (val) {
    return this.data.height(val);
};
